/** A failed API call, carrying the stable machine-readable code from the envelope. */
export class ApiError extends Error {
  readonly code: string;
  readonly status: number;
  readonly fieldErrors: Readonly<Record<string, string>>;

  constructor(
    code: string,
    message: string,
    status: number,
    fieldErrors: Record<string, string> = {},
  ) {
    super(message);
    this.name = "ApiError";
    this.code = code;
    this.status = status;
    this.fieldErrors = fieldErrors;
  }
}

export const NETWORK_ERROR = "NETWORK_ERROR";

interface ErrorBody {
  code?: unknown;
  message?: unknown;
  data?: { field_errors?: unknown } | null;
}

export function apiErrorFrom(body: unknown, response: Response): ApiError {
  const error = (typeof body === "object" && body !== null ? body : {}) as ErrorBody;
  const fieldErrors = error.data?.field_errors;
  return new ApiError(
    typeof error.code === "string" ? error.code : "HTTP_" + String(response.status),
    typeof error.message === "string" ? error.message : response.statusText,
    response.status,
    typeof fieldErrors === "object" && fieldErrors !== null
      ? (fieldErrors as Record<string, string>)
      : {},
  );
}

export function isApiError(error: unknown, ...codes: string[]): error is ApiError {
  return error instanceof ApiError && (codes.length === 0 || codes.includes(error.code));
}
